import { useEffect } from 'react';

const APP_NAME = 'aiai·loop';

/**
 * Sets the browser tab title for the current page as `<title> · aiai·loop`.
 * Pass `null`/`undefined` (e.g. while a detail page's data is still loading) to
 * show the bare app name until the real title is known. Restores the app name
 * on unmount so a stale page title never lingers after navigation. `appName`
 * lets the ops console use its own suffix.
 */
export function useDocumentTitle(title?: string | null, appName: string = APP_NAME): void {
  useEffect(() => {
    document.title = title ? `${title} · ${appName}` : appName;
    return () => {
      document.title = appName;
    };
  }, [title, appName]);
}
